// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"121a3a5e","466":"f35ec44b","738":"2984b812","856":"12c4b1a7"}[chunkId] + ".chunk.js";
};